import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classnames from 'classnames'
import PropTypes from 'prop-types'

// Utils
import { forceHistory } from '../../../composables'

// Selectors
import {
  selectCustomerProfile,
  selectOfficeProfile,
  selectCorporateProfile,
  selectFullName,
  selectCustomerPhotoUri,
} from '../../../store/selectors/customerProfile'

// Components
import { ArrowIcon } from '../DropdownSelect/ArrowIcon'
import { Text, Dropdown, Avatar } from '../..'

import OfficeInfo from './OfficeInfo'
import ContactInfo from './ContactInfo'

// Styles
import styles from './AgentDropdown.module.scss'

const propTypes = {
  className: PropTypes.string,
}

const AgentDropdown = ({ className }) => {
  const dispatch = useDispatch()
  const customerProfile = useSelector(selectCustomerProfile)
  const officeProfile = useSelector(selectOfficeProfile) || {}
  const corporateProfile = useSelector(selectCorporateProfile) || {}
  const { avatarUri: logo, name: corporateName } = corporateProfile
  const customerName = useSelector(selectFullName)
  const customerPhoto = useSelector(selectCustomerPhotoUri)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    dispatch(forceHistory)
  }, [dispatch])

  if (!(customerProfile && officeProfile)) {
    return null
  }

  return (
    <Dropdown
      className={className}
      open={open}
      setOpen={setOpen}
      buttonProps={{
        className: classnames(styles.dropdownButton, open && styles.open),
        wrapperClassName: styles.dropdownButtonWrapper,
        children: (
          <div className={styles.avatarWrapper}>
            <Avatar className={styles.avatar} src={logo} />
            <ArrowIcon
              className={classnames(styles.arrowIcon, open && styles.openArrow)}
            />
          </div>
        ),
      }}
      dropdownToggleProps={{
        className: styles.dropdownContainer,
      }}
      segmentedDropdown={false}
    >
      <div className={styles.dropdown}>
        <Avatar src={customerPhoto} className={styles.customerPhoto} />
        <address className={styles.address}>
          <div className={styles.companyAndCustomerName}>
            <Text
              variant='neutralCool'
              variantCount='600'
              size='xxs'
              className={styles.companyName}
            >
              {corporateName}
            </Text>
            <Text
              size='m'
              variant='neutralCool'
              variantCount='900'
              weight='bold'
            >
              {customerName}
            </Text>
          </div>
          <OfficeInfo />
          <ContactInfo />
        </address>
      </div>
    </Dropdown>
  )
}
AgentDropdown.propTypes = propTypes

export default AgentDropdown
